import 'scroll-behavior-polyfill';
import SentryUtils from 'app/utils/sentry';
import UserpilotUtils from 'app/utils/userpilot';
import DataLayer from 'app/utils/dataLayer';
import HotjarUtils from 'app/utils/hotjar';
import HeapUtils from 'app/utils/heap';
import { initializeAppLanguage } from 'app/modules/translations/hooks/useAppLanguage';
import { CognitoTokenManager } from 'app/modules/auth/utils/cognitoTokenManager';
import { seedLocalDevSessionIfEnabled } from 'app/modules/auth/utils/localDevLogin';

export default function beforeInit() {
  seedLocalDevSessionIfEnabled();
  CognitoTokenManager.validateAccountDomain();
  SentryUtils.init();
  UserpilotUtils.init();
  DataLayer.loadScript();
  HotjarUtils.loadScript();
  HeapUtils.loadScript();
  fixNodeGoogleTranslateAppCrashes();
  initializeAppLanguage();
}

function fixNodeGoogleTranslateAppCrashes() {
  // https://github.com/facebook/react/issues/11538#issuecomment-417504600
  if (typeof Node === 'function' && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild;
    // @ts-ignore
    Node.prototype.removeChild = function (child) {
      if (child.parentNode !== this) {
        if (console) {
          // eslint-disable-next-line no-console
          console.error(
            'Cannot remove a child from a different parent',
            child,
            this,
          );
        }
        return child;
      }
      // @ts-ignore
      return originalRemoveChild.apply(this, arguments);
    };

    const originalInsertBefore = Node.prototype.insertBefore;
    // @ts-ignore
    Node.prototype.insertBefore = function (newNode, referenceNode) {
      if (referenceNode && referenceNode.parentNode !== this) {
        if (console) {
          // eslint-disable-next-line no-console
          console.error(
            'Cannot insert before a reference node from a different parent',
            referenceNode,
            this,
          );
        }
        return newNode;
      }
      // @ts-ignore
      return originalInsertBefore.apply(this, arguments);
    };
  }
}
